export const SIZE_S = 's';
export const SIZE_M = 'm';
export const SIZE_L = 'l';
